module.exports = __webpack_public_path__ + "static/media/Venta Internet Satelital 1018 v9 Final.64844a4b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Venta Internet Satelital 1018 v9 Final.pdf
// module id = 304
// module chunks = 0